import React from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

const { Option } = Select;

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (value: string) => {
    i18n.changeLanguage(value);
  };

  return (
    <Select
      defaultValue={i18n.language}
      style={{ width: 120 }}
      onChange={handleLanguageChange}
    >
      <Option value="en">English</Option>
      <Option value="es">Español</Option>
      <Option value="zh-TW">繁體中文</Option>
      <Option value="ja">日本語</Option>
      <Option value="ko">한국어</Option>
      <Option value="fr">Français</Option>
      <Option value="it">Italiano</Option>
      <Option value="zh">简体中文</Option>
    </Select>
  );
};

export default LanguageSwitcher; 